import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation files
import enTranslations from './locales/en.json';
import daTranslations from './locales/da.json';

// Configure i18next
i18n
  // Detect user language
  .use(LanguageDetector)
  // Pass the i18n instance to react-i18next
  .use(initReactI18next)
  // Initialize i18next
  .init({
    resources: {
      en: {
        translation: enTranslations
      },
      da: {
        translation: daTranslations
      }
    },
    fallbackLng: 'en', // Fallback language if translation is missing
    debug: process.env.NODE_ENV === 'development', // Enable debug in development
    
    interpolation: {
      escapeValue: false // React already escapes values
    },
    
    detection: {
      // Order of language detection methods
      order: ['localStorage', 'navigator'],
      // Keys to lookup language from
      lookupLocalStorage: 'wordrive-language',
      // Cache user language
      caches: ['localStorage'],
    },
    
    // Supported languages
    supportedLngs: ['en', 'da'],
    
    // Namespace configuration (we use default 'translation')
    ns: ['translation'],
    defaultNS: 'translation',
  });

export default i18n;

